import WebSpeechAdapter from './WebSpeechAdapter';
import AzureSpeechAdapter from './AzureSpeechAdapter';

// ==============================|| SPEECH ADAPTER FACTORY ||============================== //
//
// Default provider: Azure Cognitive Services when credentials are present, otherwise
// falls back to the browser's Web Speech API so the mic icon is never hidden just
// because Azure keys are not configured.
//

const adapters = {
  azure: () => new AzureSpeechAdapter(),
  web: () => new WebSpeechAdapter()
};

/**
 * Get a speech adapter.
 * - 'azure': Azure Cognitive Services (requires VITE_AZURE_SPEECH_KEY + VITE_AZURE_SPEECH_REGION)
 * - 'web': Browser Web Speech API (Chrome/Edge, no key needed)
 * - 'auto' (default): Azure if credentials are present, Web Speech otherwise.
 * @param {'web' | 'azure' | 'auto'} [provider]
 * @returns {import('./SpeechAdapter').SpeechAdapter | null}
 */
export function getSpeechAdapter(provider = 'auto') {
  if (provider === 'auto') {
    const azure = new AzureSpeechAdapter();
    return azure.isSupported() ? azure : new WebSpeechAdapter();
  }
  const factory = adapters[provider];
  if (!factory) return null;
  return factory();
}

export default getSpeechAdapter;
